import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

const RecentPlanExpiredCard = () => {
  const [activeTab, setActiveTab] = useState("expired");

  const expired = [
    {
      name: "Silicon Corp",
      date: "10 Apr 2025",
      plan: "Basic (Monthly)",
      img: "/assets/img/icons/company-icon-16.svg",
    },
    {
      name: "Hubspot",
      date: "12 Jun 2025",
      plan: "Enterprise (Yearly)",
      img: "/assets/img/icons/company-icon-14.svg",
    },
    {
      name: "Licon Industries",
      date: "16 Jun 2025",
      plan: "Advanced (Monthly)",
      img: "/assets/img/icons/company-icon-18.svg",
    },
    {
      name: "TerraFusion Energy",
      date: "12 May 2025",
      plan: "Enterprise (Monthly)",
      img: "/assets/img/company/company-07.svg",
    },
    {
      name: "Epicurean Delights",
      date: "15 May 2025",
      plan: "Premium (Yearly)",
      img: "/assets/img/company/company-08.svg",
    },
  ];

  return (
    <Card className="shadow-sm border-0 d-flex flex-column h-100 m-0">
      <Card.Header className="bg-white d-flex justify-content-between align-items-center">
        <h5 className="mb-0 fw-semibold">Recent Plan Expired</h5>

        <Dropdown>
          <Dropdown.Toggle variant="light" size="sm">
            {activeTab === "expired" ? "Expired" : "Request"}
          </Dropdown.Toggle>
          <Dropdown.Menu align="end">
            <Dropdown.Item onClick={() => setActiveTab("expired")}>
              Expired
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setActiveTab("request")}>
              Request
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      <Card.Body className="flex-grow-1">
        {expired.map((item, i) => (
          <div
            key={i}
            className="d-flex justify-content-between align-items-center mb-3"
          >
            <div className="d-flex align-items-center">
              <div className="bg-light rounded-circle p-2 me-3">
                <img src={item.img} alt="" width="32" />
              </div>
              <div>
                <h6 className="mb-1 fw-semibold">{item.name}</h6>
                <small className="text-muted">Expired : {item.date}</small>
              </div>
            </div>

            <div className="text-end">
              <Link className="text-decoration-underline d-block">
                Send Reminder
              </Link>
              <small className="text-muted">{item.plan}</small>
            </div>
          </div>
        ))}
      </Card.Body>
    </Card>
  );
};

export default RecentPlanExpiredCard;
